<template>
  <div>
    <v-app-bar color="primary" flat app dark>
      <v-app-bar-nav-icon
        v-if="clas"
        style="position: absolute"
        @click="toClassDiary"
      >
        <v-icon large color="white">mdi-chevron-left</v-icon>
      </v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-app-bar-title v-if="child && clas" style="min-width: fit-content;">
        {{ (child.lastName + ' ' + child.firstName).length > 14
            ? (child.lastName + ' ' + child.firstName).slice(0, 14) + '…' 
            : child.lastName + ' ' + child.firstName 
        }}
      </v-app-bar-title>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        variant="flat"
        icon
        @click="openSelectChildDialog"
        height="40"
        width="40"
      >
        <v-icon color="white">
          mdi-arrow-down-drop-circle-outline
        </v-icon>
      </v-btn>
    </v-app-bar>

    <div @click="openDateDialog">
      <DatePager :date="date" @addDay="addDay" @subtractDay="subtractDay" />
    </div>
    <div class="content-wrapper">
      <div class="title-wrapper pa-1 px-3">
        <h5>{{ $t('records.parentsRecordTitle') }}</h5>
      </div>

      <VueLoading v-if="fetchLoading" :height="'50vh'" />

      <div v-else>
        <div class="subtitle-wrapper pa-1 px-3">
          <h5>{{ $t('records.sleepTime') }}</h5>
        </div>
        <v-list>
          <v-list-item v-for="(sleep, index) in childReport.sleeps" :key="`${index}-sleeps`">
            <v-list-item-content class="pa-0">
              <div class="d-flex align-center">
                {{ formatTime(sleep.from) }} 〜 {{ formatTime(sleep.to) }}
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <div class="subtitle-wrapper pa-1 px-3">
          <h5>{{ $t('records.temperature') }}</h5>
        </div>
        <v-list>
          <v-list-item v-for="(temperature, index) in childReport.temperatures" :key="`${index}-temperatures`">
            <v-list-item-content class="pa-0">
              <div class="d-flex align-center">
                <div class="mr-3 text-grey">{{ formatTime(temperature.recordedAt) }}</div>
                <div>{{ temperature.temperature.toFixed(1) }}</div>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <div class="subtitle-wrapper pa-1 px-3">
          <h5>{{ $t('records.breakfast') }}</h5>
        </div>
        <v-list>
          <v-list-item v-for="(breakfast, index) in childReport.breakfasts" :key="`${index}-breakfasts`">
            <v-list-item-content class="pa-0">
              <div class="d-flex align-center">
                <p style="white-space:pre-wrap;">{{ breakfast.content }}</p>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <div class="subtitle-wrapper pa-1 px-3">
          <h5>{{ $t('records.dinner') }}</h5>
        </div>
       <v-list>
          <v-list-item v-for="(dinner, index) in childReport.dinners" :key="`${index}-dinners`">
            <v-list-item-content class="pa-0">
              <div class="d-flex align-center">
                <p style="white-space:pre-wrap;">{{ dinner.content }}</p>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <div class="subtitle-wrapper pa-1 px-3">
          <h5>{{ $t('records.milk') }}</h5>
        </div>
         <v-list>
          <v-list-item v-for="(milk, index) in childReport.milks" :key="`${index}-milks`">
            <v-list-item-content class="pa-0">
              <div class="d-flex align-center">
                <div class="mr-3 text-grey">{{ formatTime(milk.recordedAt) }}</div>
                <div class="mr-3">{{ showMilkCategory(milk.milkCategory) }}</div>
                <div>{{ milk.amount? milk.amount.value + 'cc': $t('records.unknown')  }}</div>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <div class="subtitle-wrapper pa-1 px-3">
          <h5>{{ $t('records.defecation') }}</h5>
        </div>
        <v-list>
          <v-list-item v-for="(defecation, index) in childReport.defecations" :key="`${index}-defecations`">
            <v-list-item-content class="pa-0">
              <div class="d-flex align-center">
                <div class="mr-3 text-grey">{{ formatTime(defecation.recordedAt) }}</div>
                <div>{{ showDefecationStatus(defecation.state) }}</div>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </div>
    <v-snackbar v-model="snackbar" :timeout="timeout" outlined top color="primary">
      {{ snackBarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="outline-primary" text v-bind="attrs" @click="snackbar = false">
          ×
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog
      v-model="dialogFlg"
      width="280px"
      scrollable
    >
      <v-card class="selectItemList pb-0">
        <v-card-title>
          <v-select
            v-model="selectedClass"
            :items="classList"
            item-title="className"
            item-value="classId"
            @update:model-value="selectChildItems"
            variant="filled"
            hide-details
            return-object
            color="rgb(105,105,105)"
          >
          </v-select>
        </v-card-title>

        <v-card-text style="height: 40vh" class="childList">
          <v-list>
            <v-list-item
              v-for="(c, index) in childList"
              :key="index"
              @click="toClassChildrenRecords(c)"
            >
              <!-- v-list-item-contentは廃止されたため、直接titleとして記述 -->
              <v-list-item-title>{{ c.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dateDialogFlg"
      width="auto"
      max-width="100%"
    >
      <v-card>
        <v-date-picker
          v-model="selectedDate"
          type="date"
          :day-format="(date) => new Date(date).getDate()"
          @update:model-value="dateSelected"
          no-title
          hide-header
          color="primary"
        >
        </v-date-picker>
      </v-card>
    </v-dialog>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from "vue";

import DatePager from '@/components/molecules/DatePager.vue';

import dayjs from 'dayjs';
import VueLoading from '@/components/pages/Loding.vue';
import LocalDataService from '@/service/LocalDataService';
import { nurseryModule } from '@/store/dataModules/nurseryModule';
import { childrenModule } from '@/store/dataModules/childrenModule';
import { diaryReportModule } from '@/store/dataModules/diaryReportModule';
import { getDayjsInstanceTz} from 'chaild-api/src/common/moment/momentUtils';
import {
  DailyReportResponse,
  DefecationStatusType,
  DiaryResponse,
  NurseryChildResponse,
  NurseryClassResponse,
} from 'chaild-api/lib';
export default defineComponent({
  components: {
    DatePager,
    VueLoading,
  },
  data: () => {
    return {
      year: dayjs().year(),
      month: dayjs().month(),
      dialogFlg: false,
      dateDialogFlg: false,
      selectedDate: dayjs().format('YYYY-MM-DD'),
      addflg: false,
      subtractflg: false,
      loadFlg: false,
      selectedClass: '' as any,
      childList: [] as any,
      classList: [] as any,
      windowHistory: '' as any,
      fetchLoading: false,
      date: '' as any,
      timeout: 2000,
      snackBarText: '',
      snackbar: false,
      classId: 0,
      childId: 0,
    };
  },
  computed: {
    clas(): NurseryClassResponse | null {
      if (nurseryModule.clas) {
        return nurseryModule.clas;
      }
      return null;
    },
    child(): NurseryChildResponse | null {
      if (childrenModule.child) {
        return childrenModule.child;
      }
      return null;
    },
    childReport() {
      if (diaryReportModule.childReport.length > 0) {
        return diaryReportModule.childReport[0].home;
      }
      return [];
    },
  },
  watch: {
    date: {
      handler() {
        this.init();
        this.selectClassItems();
      },
      deep: true,
    },
  },
  methods: {
    //クラス情報取得（開いている個人日誌の日付を元に取得）
    async selectClassItems() {
      this.classList = [];
      this.month = dayjs(this.date).month();
      this.year = dayjs(this.date).year();
      if (this.month < 7) {
        this.year = this.year - 1;
      }
      const user = LocalDataService.getUser();
      let nurserySchool = user?.nurserySchools.find(nursery => nursery.isDefault === true);
      const nurseryId = nurserySchool?.nurseryId;
      if (nurseryId && this.year) {
        const classList = nurseryModule.getNurseryClassWithYear({
          nurseryId: nurseryId,
          year: this.year
        })
        this.classList = (await classList);
      }
      if (this.classList.length === 0) {
        this.classList.push({
          classId: 0,
          className: (this as any).$t('records.noClassAssigned') as string,
        });
      }
    },
    //選択されているクラスに登録されている園児情報取得
    async selectChildItems() {
      this.childList = [];
      this.loadFlg = true;
      this.month = dayjs(this.date).month();
      this.year = dayjs(this.date).year();
      if (this.month < 7) {
        this.year = this.year - 1;
      }
      const user = LocalDataService.getUser();
      let nurserySchool = user?.nurserySchools.find(nursery => nursery.isDefault === true);
      const nurseryId = nurserySchool?.nurseryId;
      if (this.selectedClass.year == this.year && nurseryId) {
        const listData =  childrenModule.getChildren({
          nurseryId:nurseryId,
          classId: this.selectedClass.classId,
        });

        const arr = (await listData).children;
        const len = arr.length;
        const baseDay = getDayjsInstanceTz(this.date);
        for (let i = 0; i < len; i++) {
          if ((arr[i].graduationDate && baseDay.isAfter(getDayjsInstanceTz(arr[i].graduationDate!))) // 卒園済
            || (arr[i].quitDate && baseDay.isAfter(getDayjsInstanceTz(arr[i].quitDate!))) // 退園・転園済
            || (arr[i].admissionDate && getDayjsInstanceTz(arr[i].admissionDate).isAfter(baseDay)) // 入園前
          ) {
            continue;
          }
          this.childList.push({
            childId: arr[i].childId,
            name: arr[i].lastName + arr[i].firstName,
          })
        }
        this.loadFlg = false;
        return this.childList;
      } else {
        this.loadFlg = false;
      }
    },
    //選択した園児の個人日誌のページに遷移
    async toClassChildrenRecords(child: NurseryChildResponse) {
      if (this.windowHistory === '') {
        this.windowHistory = this.$route.params.classId;
      }

      //現在開いている園児以外を選択した時のみ this.$router.push を行う
      const childId = `${child.childId}`;
      if (this.$route.params.childId != childId) {
        await this.$router.push({
          path: `/record/parents-record/class/${this.selectedClass.classId}/child/${child.childId}`,
          query: { date: `${this.date.toISOString()}` }
        });
      }

      await this.init();
      this.dialogFlg = false;
    },
    openSelectChildDialog() {
      this.dialogFlg = true;
      this.selectedClass = this.clas;
      this.selectChildItems();
    },
    addDay() {
      this.date = this.date.add(1, 'd');
      this.addflg = true;
    },
    subtractDay() {
      this.date = this.date.subtract(1, 'd');
      this.subtractflg = true;
    },
    openDateDialog() {
      if (this.addflg || this.subtractflg) {
        this.addflg = false;
        this.subtractflg = false;
        return
      }
      this.selectedDate = this.date.format('YYYY-MM-DD');
      this.dateDialogFlg = true;
    },
    dateSelected(day) {
      this.date = dayjs(day);
      this.selectedDate = dayjs(day).format('YYYY-MM-DD');
      this.dateDialogFlg = false;
    },
    formatTime(time: string) {
      const nowTime = dayjs(time).format('HH:mm');
      return nowTime;
    },
    showDefecationStatus(state: DefecationStatusType) {
      const t = (this as any).$t;
      if (state === 'hard') {
        return t('defecation.hard');
      } else if (state === 'normal') {
        return t('defecation.normal');
      } else if (state === 'soft') {
        return t('defecation.soft');
      } else if (state === 'diarrhea') {
        return t('defecation.diarrhea');
      }
      return '';
    },
    showMilkCategory(category: string) {
      const t = (this as any).$t;
      if (category === 'breast') {
        return t('milk.breastMilk');
      } else if (category === 'formula') {
        return t('milk.formulaMilk');
      }
      return '';
    },
    toClassDiary() {
      const classId = this.child?.nurseryClasses[0].classId;
      if (classId) {
        this.$router.push(`/record/class/${classId}`);
      }
    },
    init: async function() {
      try {
        this.fetchLoading = true;
        const user = LocalDataService.getUser();
        const classId = this.$route.params.classId as string;
        const childId = this.$route.params.childId as string;
        this.classId = parseInt(classId, 10);
        this.childId = parseInt(childId, 10);
        if (user) {
          let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
          if (!nurserySchool) {
            nurserySchool = user.nurserySchools[0];
          }
          const nurseryId = nurserySchool.nurseryId;
          Promise.all([
            nurseryModule.getNurseryClassDetail({
              nurseryId,
              classId: this.classId,
            }),
            childrenModule.getChild(this.childId),
          ]);
          await diaryReportModule.fetchChildReport({
            childId: this.childId,
            from: this.date.format('YYYY-MM-DD'),
            to: this.date.format('YYYY-MM-DD'),
          });
        }
      } catch {
      } finally {
        this.fetchLoading = false;
      }
    },
  },
  async created() {
    const date = this.$route.query.date as string
    if (date) {
      const temp = dayjs(date);
      this.date = temp
    } else {
      this.date = dayjs();
    }
  },
  async mounted() {
    this.init();
  },
  beforeDestroy() {
    childrenModule.refreshChild();
    nurseryModule.refreshClass();
  },
});
</script>
<style lang="scss" scoped>
@use '@/sass/variables.scss' as *;

.content-wrapper {
  height: 100%;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
    -webkit-appearance: none;
  }
}

.title-wrapper {
  color: #ffffff;
  background-color: rgb(var(--v-theme-primary));
}
.subtitle-wrapper {
  color: #a3a4a4;
  background-color: #f5f6f6;
}
</style>
